import React, { useState, useEffect } from "react";
import {
    Grid,
    Box,
    Button,
    Avatar,
    Typography,
    Paper,
    Divider
} from "@mui/material";
import { ArrowLeft2, User, Sms, Call, Briefcase, Location } from "iconsax-react";
import { useNavigate } from "react-router-dom";
import Snackbar1 from "../../../../components/ui/Snackbar";
import Loader from "../../../../components/ui/LoaderContainer";

const EditAdminProfile = ({ login, client, updateProfile, close_snack_bar, snackbar }) => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
        username: "",
        email: "",
        mobile: "",
        industry: "",
        address: ""
    });

    useEffect(() => {
        if (login) {
            setFormData({
                name: login.name || "",
                username: login.username || "",
                email: login.email || "",
                mobile: login.mobile || "",
                industry: login.industry || "",
                address: login.address || ""
            });
        }
    }, [login]);

    const InfoCard = ({ icon, label, value }) => (
        <Paper
            elevation={0}
            sx={{
                p: { xs: 2, md: 2.5 },
                border: "1px solid #e0e0e0",
                borderRadius: "16px",
                display: "flex",
                alignItems: "center",
                gap: 2,
                transition: "all 0.2s",
                "&:hover": {
                    borderColor: "#031634",
                    boxShadow: "0 4px 12px rgba(3, 22, 52, 0.08)",
                    transform: "translateY(-1px)"
                }
            }}
        >
            <Box
                sx={{
                    p: 1.5,
                    borderRadius: "12px",
                    bgcolor: "#f5f8ff",
                    color: "#031634",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "48px", // Prevent icon shrink
                    minHeight: "48px"
                }}
            >
                {icon}
            </Box>
            <Box sx={{ overflow: "hidden", width: "100%" }}>
                <Typography variant="caption" color="textSecondary" fontWeight={600} textTransform="uppercase" letterSpacing={0.5}>
                    {label}
                </Typography>
                <Typography
                    variant="body1"
                    fontWeight={600}
                    color="#031634"
                    sx={{
                        wordBreak: "break-word",
                        whiteSpace: "normal"
                    }}
                >
                    {value || "Not Provided"}
                </Typography>
            </Box>
        </Paper>
    );

    return (
        <Box sx={{ width: "100%", pb: 4, minHeight: "80vh", px: { xs: 2, md: 6 }, pt: 4 }}>
            {/* Simple Header */}
            <Box mb={4} maxWidth="lg" mx="auto">
                <Button
                    startIcon={<ArrowLeft2 />}
                    sx={{
                        color: "#031634",
                        textTransform: "none",
                        mb: 2,
                        pl: 0,
                        "&:hover": { bgcolor: "transparent", color: "#1a237e" }
                    }}
                    onClick={() => navigate(-1)}
                >
                    Back
                </Button>
                <Typography variant="h4" fontWeight="800" color="#031634">
                    Profile Details
                </Typography>
            </Box>

            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={12} md={10} lg={8}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: { xs: 3, md: 5 },
                            borderRadius: "24px",
                            border: "1px solid #f0f0f0",
                            bgcolor: "#fff"
                        }}
                    >
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <InfoCard
                                    icon={<User size="24" variant="Bold" />}
                                    label="Full Name"
                                    value={formData.name}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InfoCard
                                    icon={<User size="24" variant="Outline" />}
                                    label="Username"
                                    value={formData.username}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InfoCard
                                    icon={<Sms size="24" variant="Bold" />}
                                    label="Email Address"
                                    value={formData.email}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InfoCard
                                    icon={<Call size="24" variant="Bold" />}
                                    label="Mobile Number"
                                    value={formData.mobile}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InfoCard
                                    icon={<Briefcase size="24" variant="Bold" />}
                                    label="Industry"
                                    value={formData.industry}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InfoCard
                                    icon={<Location size="24" variant="Bold" />}
                                    label="Address"
                                    value={formData.address}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>

            {/* Hidden Loader/Snackbar components if still needed by parent props */}
            <Loader />
            <Snackbar1
                open={snackbar?.response_received}
                message={snackbar?.message}
                close_snack_bar={close_snack_bar}
            />
        </Box>
    );
};

export default EditAdminProfile;
